import clsx, { ClassValue } from 'clsx';
import React, { CSSProperties, HTMLProps, MouseEventHandler, ReactNode } from 'react';
import classNames from './ButtonWeb.module.css';

export interface ButtonWebProps extends Omit<HTMLProps<HTMLButtonElement>, 'className'> {
  children?: ReactNode;
  type?: 'submit' | 'reset' | 'button' | undefined;
  onClick: MouseEventHandler<HTMLButtonElement>;
  onDoubleClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  className?: ClassValue;
  disabled?: boolean;
  testID?: string;
}

// Unstyled button. Use for clickable elements that don't fit existing styled components.
export function ButtonWeb({
  children,
  type = 'button',
  disabled = false,
  className,
  onClick = () => {},
  onDoubleClick = () => {},
  style = {},
  testID,
}: ButtonWebProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      disabled={disabled}
      className={clsx(classNames.buttonWeb, className)}
      style={style}
      data-testid={testID}
    >
      {children}
    </button>
  );
}
